<template>
    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                修改密码
            </blockquote>
        </div>

        <div class="layui-card-body" style="min-height: 465px;">
            <div class="w-580" style="padding-top: 50px;">
                <div class="layui-form" lay-filter="">
                    <div class="layui-form-item">
                        <label class="layui-form-label">当前密码</label>
                        <div class="layui-input-inline">
                            <el-input placeholder="请输入密码" v-model="atPresentPassword" show-password></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">新密码</label>
                        <div class="layui-input-inline">
                            <el-input placeholder="请输入密码" v-model="newPassword" show-password></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">确认新密码</label>
                        <div class="layui-input-inline">
                            <el-input placeholder="请输入密码" v-model="affirmNewPassword" show-password></el-input>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label"></label>
                        <div class="layui-input-block">
                            <a class="layui-btn layui-btn-sm layui-btn-normal" @click="affirmModification">确认修改</a>
                            <button type="reset" class="layui-btn layui-btn-sm layui-btn-primary rest-btn"
                                @click="reset">重置</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                atPresentPassword: '',
                newPassword: '',
                affirmNewPassword: ''
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            affirmModification() {
                if (this.atPresentPassword === '') {
                    this.$message({
                        message: '请填写当前密码',
                        type: 'warning'
                    });
                    return false;
                } else if (this.newPassword === '') {
                    this.$message({
                        message: '请填写新密码',
                        type: 'warning'
                    });
                    return false;
                } else if (this.affirmNewPassword === '') {
                    this.$message({
                        message: '请填写确认密码',
                        type: 'warning'
                    });
                    return false;
                } else if (this.newPassword != this.affirmNewPassword) {
                    this.$message({
                        message: '两次密码输入不一致!',
                        type: 'warning'
                    });
                    return false;
                }
                let parames = new URLSearchParams();
                parames.append('id', this.$storage.get('declareUser').id);
                parames.append('passWord', this.atPresentPassword);
                this.$axios.post(this.serverUrl + '/checkPassWord', parames).then(resp => {
                    if (resp.data.code === 1) {
                        let parames = new URLSearchParams();
                        parames.append('id', this.$storage.get('declareUser').id);
                        parames.append('passWord', this.affirmNewPassword);
                        this.$axios.post(this.serverUrl + '/updatePassWord', parames).then(resp => {
                            if (resp.data.code === 1) {
                                this.$message({
                                    message: '恭喜你，密码重置成功！！',
                                    type: 'success'
                                });
                                this.atPresentPassword = '';
                                this.newPassword = '';
                                this.affirmNewPassword = '';
                            } else {
                                this.$message({
                                    message: '密码重置失败！',
                                    type: 'success'
                                });
                            }
                        }).catch(err => {

                        })

                    } else if (resp.data.code === 2) {
                        this.$message({
                            message: '原始密码不正确！',
                            type: 'success'
                        });
                    }

                }).catch(err => {

                })

            },
            reset() {
                this.atPresentPassword = '';
                this.newPassword = '';
                this.affirmNewPassword = '';
            }
        }
    }
</script>

<style scoped>
    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    .layui-form-item .layui-input-inline {
        float: left;
        width: 190px;
        margin-right: 10px;
    }

    .layui-form-label {
        min-width: 114px;
        width: auto;
        float: left;
        display: block;
        padding: 9px 15px;
        width: 80px;
        font-weight: 400;
        line-height: 20px;
        text-align: right;
    }

    .layui-form-item {
        margin-bottom: 15px;
        clear: both;
        *zoom: 1;
    }

    .w-580 {
        width: 580px;
        margin: 0 auto;
        position: relative;
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmChangePassword.vue